export const MODAL_HEADER_TEST_ID = 'command-palette.ui.modal.header.modal-header';
